import { useState } from "react";

const getInitials = (name = "") => {
  if (!name) return "";

  let parts = name.trim().split(/\s+/); // split by spaces
  let clean = parts.filter((p) => p.toLowerCase() !== "team"); // remove "Team"

  if (clean.length === 2) {
    return clean[0][0].toUpperCase() + clean[1][0].toUpperCase();
  }

  if (clean.length === 1 && parts.length === 2) {
    return "T" + clean[0][0].toUpperCase();
  }

  if (clean.length === 1) {
    return clean[0].slice(0, 2).toUpperCase();
  }

  if (clean.length >= 3) {
    return clean[0][0].toUpperCase() + clean[clean.length - 1][0].toUpperCase();
  }

  return "";
};

const Avatar = ({ src, title, width = '1.75rem', height = '1.75rem', fontSize = 12, className, ...props }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <>
      {src && !imgError ? (
        <img
          className={`myAvatar shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center ${className}`}
          src={src}
          alt={title}
          style={{ width: width, height: height }}
          onError={() => setImgError(true)} // fallback on error
          {...props}
        />
      ) : (
        <div
          className={`myAvatar shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium ${className}`}
          style={{ width: width, height: height, fontSize: fontSize }}
          {...props}
        >
          {getInitials(title)}
        </div>
      )}
    </>
  );
};

export default Avatar;
